import React from "react";
import { useTranslation } from "react-i18next";
import FavoriteTable from "src/components/favorite_page/FavoriteTable";
import { Breadcrumbs, BreadcrumbItem } from "@nextui-org/react";

const Favorite: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="text-[33px] capitalize text-navy-700 mt-4">
        <div className="font-bold capitalize hover:text-navy-700">
          {t("Favorite")}
        </div>
      </div>

      {/* Breadcrumbs */}
      <Breadcrumbs isDisabled className="mb-5">
        <BreadcrumbItem>{t("SAFFCLOUD")}</BreadcrumbItem>
        <BreadcrumbItem>{t("Favorite")}</BreadcrumbItem>
      </Breadcrumbs>

      <div>
        <FavoriteTable />
      </div>
    </>
  );
};

export default Favorite;